<template src="./sugerenciasTamanos.html"></template>
<script>
export default {
    
}
</script>

<style lang="scss" scoped src="./sugerenciasTamanos.scss">

</style>


// WEBPACK FOOTER //
// src/components/sugerenciasTamanos/sugerenciasTamanos.vue